import store from '@/store';
import { AICHAT_ATTR } from '../constants/helpConstants';
import { resolveHelpDestination, buildHelpLaunch } from '../utils/helpRules';

// See ../README.md for the three destinations, the data-aichat contract, and the helpers for
// help links passed as props into Design System components.

export function helpDestination() {
  return resolveHelpDestination(store.getters);
}

export function openHelp(options) {
  store.dispatch('AiChatStore/launchWorkflow', buildHelpLaunch(options));
}

export function helpLinkProp(value) {
  return helpDestination() === 'none' ? '' : value;
}

export function routeHelpLinkClick(event, { message, source } = {}) {
  const destination = helpDestination();
  if (destination === 'external') return destination;
  event?.preventDefault?.();
  if (destination === 'chat') openHelp({ message, source });
  return destination;
}

export function routeHelpAnchorClick(event, options) {
  if (!event?.target?.closest?.('a.VcLink')) return null;
  return routeHelpLinkClick(event, options);
}

export function handleHelpLinkClick(event) {
  const anchor = event?.target?.closest?.(`a[${AICHAT_ATTR}]`);
  if (!anchor) return;
  const destination = helpDestination();
  if (destination === 'external') return;
  event.preventDefault();
  event.stopPropagation();
  if (destination === 'chat') openHelp({ message: anchor.getAttribute(AICHAT_ATTR), source: 'help_article' });
}

export function installHelpLinkCatcher(doc = document) {
  doc.addEventListener('click', handleHelpLinkClick, true);
}

export function syncHelpLinkVisibility() {
  document.body.classList.toggle('bizai-help-hidden', helpDestination() === 'none');
}
